import { useMutation, useQuery } from "react-query";

import {
  createPolicyAppliance,
  getApplianceFreeQuote,
  getApplianceManufacturers,
  getDeviceCategories,
  preCreatePolicyPaymentAppliance,
} from "./appliances-service";
import { ICreatePolicyApplianceReq } from "./appliances-service.interface";

export const useGetDeviceCategories = () => {
  return useQuery("appliances/categories", () => getDeviceCategories());
};

export const useGetApplianceManufacturers = (sponsorId: string) => {
  return useMutation((deviceType: string) =>
    getApplianceManufacturers(sponsorId, deviceType),
  );
};

export const useGetApplianceFreeQuote = (sponsorId: string) => {
  return useMutation((insuredValue: string) =>
    getApplianceFreeQuote(sponsorId, insuredValue),
  );
};

export const useCreatePolicyAppliance = () => {
  return useMutation((data: ICreatePolicyApplianceReq) =>
    createPolicyAppliance(data),
  );
};

export const usePreCreatePolicyPaymentAppliance = () => {
  return useMutation((data: ICreatePolicyApplianceReq) =>
    preCreatePolicyPaymentAppliance(data),
  );
};
